export enum MsgBoxButtons {
  OK,
  OKCancel,
  AbortRetryIgnore,
  YesNoCancel,
  YesNo,
  RetryCancel,
  DeleteConfirm
}

export enum MsgBoxIcon {
  None,
  Error,
  Question,
  Warning,
  Information
}

export enum DialogResult {
  OK,
  Cancel,
  Abort,
  Retry,
  Ignore,
  Yes,
  No
}

export enum TextColor {
  Default,
  Danger,
  Info,
  Secondary,
  Primary,
  Success,
  Warning,
  Light,
  Dark,
  Muted,
  White
}

export class DialogConfig {
  icon = MsgBoxIcon.Question;
  iconColor = TextColor.Info;
  buttons = MsgBoxButtons.OKCancel;

  constructor(options?: any) {
    Object.assign(this, options);
  }

  private _dialogConfig = {
    icons: {
      error: "fa fa-times-circle",
      warning: "fa fa-exclamation-triangle",
      question: "fa fa-question-circle",
      information: "fa fa-info-circle"
    },
    colors: {
      default: "text-default",
      danger: "text-danger",
      info: "text-info",
      secondary: "text-secondary",
      primary: "text-primary",
      success: "text-success",
      warning: "text-warning",
      light: "text-light bg-dark",
      dark: "text-dark",
      muted: "text-muted",
      white: "text-white bg-dark"
    },
    buttons: {
      ok: { text: "Aceptar", class: "btn-info", icon: "" },
      cancel: { text: "Cancelar", class: "btn-danger", icon: "" },
      abort: { text: "Abortar", class: "btn-danger", icon: "" },
      retry: { text: "Reintentar", class: "btn-info", icon: "" },
      ignore: { text: "Ignorar", class: "btn-warning", icon: "" },
      yes: { text: "SÃ­", class: "btn-info", icon: "" },
      no: { text: "No", class: "btn-secondary", icon: "" }
    }
  };

  createDefaultOptions(customOpts?: any) {
    const buttons = [];
    let icon = "",
      iconColor = "";

    switch (this.buttons) {
      case MsgBoxButtons.OK:
        buttons.push({
          text: this._dialogConfig.buttons.ok.text,
          class: this._dialogConfig.buttons.ok.class,
          icon: this._dialogConfig.buttons.ok.icon,
          result: DialogResult.OK
        });
        break;

      case MsgBoxButtons.OKCancel:
        buttons.push({
          text: this._dialogConfig.buttons.ok.text,
          class: this._dialogConfig.buttons.ok.class,
          icon: this._dialogConfig.buttons.ok.icon,
          result: DialogResult.OK
        });

        buttons.push({
          text: this._dialogConfig.buttons.cancel.text,
          class: this._dialogConfig.buttons.cancel.class,
          icon: this._dialogConfig.buttons.cancel.icon,
          result: DialogResult.Cancel
        });
        break;

      case MsgBoxButtons.AbortRetryIgnore:
        buttons.push({
          text: this._dialogConfig.buttons.abort.text,
          class: this._dialogConfig.buttons.abort.class,
          icon: this._dialogConfig.buttons.abort.icon,
          result: DialogResult.Abort
        });

        buttons.push({
          text: this._dialogConfig.buttons.retry.text,
          class: this._dialogConfig.buttons.retry.class,
          icon: this._dialogConfig.buttons.retry.icon,
          result: DialogResult.Retry
        });

        buttons.push({
          text: this._dialogConfig.buttons.ignore.text,
          class: this._dialogConfig.buttons.ignore.class,
          icon: this._dialogConfig.buttons.ignore.icon,
          result: DialogResult.Ignore
        });
        break;

      case MsgBoxButtons.YesNoCancel:
        buttons.push({
          text: this._dialogConfig.buttons.yes.text,
          class: this._dialogConfig.buttons.yes.class,
          icon: this._dialogConfig.buttons.yes.icon,
          result: DialogResult.Yes
        });

        buttons.push({
          text: this._dialogConfig.buttons.no.text,
          class: this._dialogConfig.buttons.no.class,
          icon: this._dialogConfig.buttons.no.icon,
          result: DialogResult.No
        });

        buttons.push({
          text: this._dialogConfig.buttons.cancel.text,
          class: this._dialogConfig.buttons.cancel.class,
          icon: this._dialogConfig.buttons.cancel.icon,
          result: DialogResult.Cancel
        });
        break;

      case MsgBoxButtons.YesNo:
        buttons.push({
          text: this._dialogConfig.buttons.yes.text,
          class: this._dialogConfig.buttons.yes.class,
          icon: this._dialogConfig.buttons.yes.icon,
          result: DialogResult.Yes
        });

        buttons.push({
          text: this._dialogConfig.buttons.no.text,
          class: this._dialogConfig.buttons.no.class,
          icon: this._dialogConfig.buttons.no.icon,
          result: DialogResult.No
        });
        break;

      case MsgBoxButtons.DeleteConfirm:
        buttons.push({
          text: this._dialogConfig.buttons.yes.text,
          class: this._dialogConfig.buttons.cancel.class,
          icon: "fa-trash",
          result: DialogResult.Yes
        });

        buttons.push({
          text: this._dialogConfig.buttons.no.text,
          class: this._dialogConfig.buttons.no.class,
          icon: this._dialogConfig.buttons.no.icon,
          result: DialogResult.No
        });
        break;

      case MsgBoxButtons.RetryCancel:
        buttons.push({
          text: this._dialogConfig.buttons.retry.text,
          class: this._dialogConfig.buttons.retry.class,
          icon: this._dialogConfig.buttons.retry.icon,
          result: DialogResult.Retry
        });

        buttons.push({
          text: this._dialogConfig.buttons.cancel.text,
          class: this._dialogConfig.buttons.cancel.class,
          icon: this._dialogConfig.buttons.cancel.icon,
          result: DialogResult.Cancel
        });
        break;
    }

    switch (this.icon) {
      case MsgBoxIcon.Error:
        icon = this._dialogConfig.icons.error;
        break;

      case MsgBoxIcon.Information:
        icon = this._dialogConfig.icons.information;
        break;

      case MsgBoxIcon.Question:
        icon = this._dialogConfig.icons.question;
        break;

      case MsgBoxIcon.Warning:
        icon = this._dialogConfig.icons.warning;
        break;
    }

    switch (this.iconColor) {
      case TextColor.Danger:
        iconColor = this._dialogConfig.colors.danger;
        break;

      case TextColor.Dark:
        iconColor = this._dialogConfig.colors.dark;
        break;

      case TextColor.Default:
        iconColor = this._dialogConfig.colors.default;
        break;

      case TextColor.Info:
        iconColor = this._dialogConfig.colors.info;
        break;

      case TextColor.Light:
        iconColor = this._dialogConfig.colors.light;
        break;

      case TextColor.Muted:
        iconColor = this._dialogConfig.colors.muted;
        break;

      case TextColor.Primary:
        iconColor = this._dialogConfig.colors.primary;
        break;

      case TextColor.Secondary:
        iconColor = this._dialogConfig.colors.secondary;
        break;

      case TextColor.Success:
        iconColor = this._dialogConfig.colors.success;
        break;

      case TextColor.Warning:
        iconColor = this._dialogConfig.colors.warning;
        break;

      case TextColor.White:
        iconColor = this._dialogConfig.colors.white;
        break;
    }

    return {
      icon: icon,
      iconColor: iconColor,
      buttons: buttons,
      callback: function(cancel) {}
    };
  }
}

export class DialogEventArgs {
  constructor(public state: string, public content?: any) {}
}
